import { useQuery } from '@tanstack/react-query';
import { legacyOrderDraftQueries } from '../api/legacy-order-draft-queries';

/** Vehicle classes supplied by the current equipment catalog. */
export function useLegacyEquipments() {
  const equipments = useQuery(legacyOrderDraftQueries.equipments());
  return {
    equipments: equipments.data ?? [],
    isLoading: equipments.isLoading,
    isError: equipments.isError,
  };
}
